"use client";

import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "@/src/firebase/firebase";
import { GoogleSVG } from "@/src/ui/AllSVG";
import { useGoogleLoginMutation } from "@/src/store/rtkQueries/userAuthApi";
import { toast } from "@/src/lib/toast";
import { setAuthCookies, setGeoCookiesFromProfile } from "@/src/utils/authCookies";
import { useDispatch } from "react-redux";
import { closeModal } from "@/src/store/slices/allModalSlice";
import { closeDrawer } from "@/src/store/slices/allDrawerSlice";
import { useRouter } from "next/navigation";
import { getFcmTokenCookie } from "@/src/utils/authCookies";
import { getClientCookieValue } from "@/src/utils/getClientCookieValue";
import { resolveEuropeanCountryCookieValue } from "@/src/utils/europeanCountryList";



export default function GoogleLogin() {
    const router = useRouter();
    const dispatch = useDispatch();
    const [googleLogin, { isLoading }] = useGoogleLoginMutation();
    const fcm_token = getFcmTokenCookie();
    const country = getClientCookieValue('user_country_code') ?? '';
    const handleLogin = async () => {
        try {
            const result = await signInWithPopup(auth, googleProvider);
            console.log('result', result);
            const idToken = await result.user.getIdToken();

            const response = await googleLogin({ idToken, country: resolveEuropeanCountryCookieValue(country ?? ''), fcm_token }).unwrap();
            // console.log('response', response);

            if (response?.http_status_code === 200 || response?.http_status_code === 201) {
                toast.success(response?.message ?? "Login successful");
                setAuthCookies({
                    token: response?.data?.token,
                    membership: response?.data?.membership || '',
                });
                setGeoCookiesFromProfile(
                    response?.data?.user?.ip ?? "",
                    response?.data?.user?.country ?? "",
                    response?.data?.user?.iso_code ??
                    response?.data?.user?.country
                );
                router.refresh();
                dispatch(closeModal());
                dispatch(closeDrawer());
            }
        } catch (error) {
            console.error("Login error:", error);
        }
    };

    return (
        <>
            <button
                type="button"
                onClick={handleLogin}
                disabled={isLoading}
                className="w-full flex items-center justify-center gap-3 border border-muted-color rounded-[10px] py-3 text-sm font-medium text-body-color hover:border-body-color/30 transition-colors bg-white disabled:opacity-50 disabled:pointer-events-none"
            >
                <GoogleSVG />
                {isLoading ? "Continuing…" : "Continue with Google"}
            </button>
        </>
    );
}
